export enum ReportOrderItemType {
  HSE = 0,
  Activities = 10,
  StatusTracker = 15,
  Weather = 20,
  Personnel = 30,
  Consumables = 40,
  Summary = 50,
  ForecastActivities = 60,
  Appendix = 70,
  FreeTextFieldsOld = 80,
  FreeTextFields = 85, // TODO: change this to 80 when we remove the old Free Text field
  Progress = 90,
  ProgressWithoutTarget = 92,
  TableOfColumns = 95,
  Attachment = 100,
  ApprovalDetails = 110,
  Signatures = 120,
  LogEvents = 130,
}
